import React from "react";
import Index from "../component/Privacy";
import Navbar from "../component/Navbar";
import Tabs from "../component/Privacy/Tabs";
import Webimageprivacy from "../component/Privacy/Webimageprivacy";

import Footer from "../component/Footer";
import Putfirst from "../component/About/Putfirst";
import Calltoaction from "../component/Calltoaction";
import FAQSection from "../component/FAQSection";
import BlogPreview from "../component/BlogPreview";

const Privacy = () => {
  return (
    <div className="bg-[#00001A] ">
      <Navbar />
 

      <Tabs />
      <Putfirst/>
      <Calltoaction/>
      <FAQSection/>
      <BlogPreview/>

      <Footer />
    </div>
  );
};

export default Privacy;
